module.exports = __webpack_public_path__ + "img/SchlafenInBasedow.aed595cc.svg";